export const ROUTES = {
    coverPage: '/',
    searchPage: '/search',
    article: {
        base: '/product',
        detail: '/product/:id',
    },
    news: {
        base: '/news',
        detail: '/news/:id',
    },
    notFound: '/not-found',
    cart: {
        base: '/cart',
        empty: '/cart/empty',
        submit: '/cart/submit',
        submitInquiry: '/cart/submit-inquiry',
        submitSingleInquiry: '/cart/submit-single-inquiry',
    },
    wishList: {
        base: '/wish-list',
        detail: '/wish-list/:id',
    },
    orders: '/orders',
    supplierDirectory: {
        base: '/supplier-directory',
        detail: '/supplier-directory/:id',
    },
    view: '/view/:slug',
};
